import React from "react"
import { Page } from "@ui/common/page/Page"
import { WorkOrdersFilterButton, WorkOrdersFilterOverlay } from "./WorkOrdersFilterOverlay"
import { WorkOrdersQuickFilters } from "./WorkOrdersQuickFilters"
import { WorkOrdersTable } from "./WorkOrdersTable"
import { ServiceRequestCreationModal } from "@ui/workRequests/ServiceRequestCreationModal"
import { CreateNewWorkOrderModal } from "./CreateNewWorkOrderModal"
import { useBlocCoordinator } from "@lib/bloc/hooks"
import { DI } from "@ui/DI"

export function WorkOrdersScreen(): JSX.Element {
    const [state, viewModel] = useBlocCoordinator(() => DI.workRequestsFilterOverlayViewModel())

    const handleWorkOrderUpdated = () => {
        viewModel.applyFilters()
    }
    return (
        <Page className="page--work-orders" filterButton={WorkOrdersFilterButton}>
            <WorkOrdersFilterOverlay />
            <WorkOrdersQuickFilters />
            <WorkOrdersTable />
            <ServiceRequestCreationModal />
            <CreateNewWorkOrderModal onWorkOrderDeleted={handleWorkOrderUpdated} onClose={(wasModified) => {
                if (wasModified) {
                    handleWorkOrderUpdated()
                }
            }} onWorkOrderCreated={handleWorkOrderUpdated} />
        </Page>
    )
}
